'use strict';

module.exports = {
  allProducts: 'allProducts',
  filteredProducts: 'filteredProducts',
};
